import { thangDiemActions } from './thangDiemActions';
export const soDiemActionsWrapper = {
    thangDiem: thangDiemActions,
}
